import React, { useCallback } from 'react';
import { Button } from '@gafe/common-ui';

import { WarningPopOver } from '@/components/generic/WarningPopOver';
import {
  getStepByName,
  markStepAsCompleted,
  useOrderContext,
} from '@/components/modals/SubmitOrder/helpers';

import { StepsName } from '../../types';
import { ProposalDetails } from '../Common/ProposalDetails';

import { AdditionalNotes } from './components/AdditionalNotes';
import { ContractAmount } from './components/ContractAmount';
import { ContractDetails } from './components/ContractDetails';
import { Financing } from './components/Financing';
import { RoofSize } from './components/RoofSize';
import { ShingleColor } from './components/ShingleColor';
import { Warranty } from './components/Warranty';
import { AddonsList } from './AddonsList';
import { nextStepValidation } from './helpers';
import { Props } from './types';

import styles from './OrderInfoStep.module.scss';

export const OrderInfoStep = ({ close, goToStep, stepName }: Props) => {
  const state = useOrderContext();

  const nextStepName = state.isDistribution ? StepsName['Services'] : StepsName['Products'];
  const productStep = getStepByName(state, StepsName['Products']);
  const servicesStep = getStepByName(state, StepsName['Services']);
  const isActivityDistributionModel = state.isAccessProgram && state.isDistribution;
  const nextStep = isActivityDistributionModel ? servicesStep : productStep;

  const goToProductsStep = useCallback(() => {
    goToStep?.(nextStep);
    markStepAsCompleted(state.wizardHeaderSteps, stepName);
  }, [goToStep, nextStep, state.wizardHeaderSteps, stepName]);

  const productErrors = nextStepValidation(state);

  return (
    <div>
      <ProposalDetails orderItems={state.visibleOrderItems} shouldDisplayPurchaseNumber={false} />
      <br />
      <ContractDetails>
        <ContractAmount />
        <Financing />
        <RoofSize />
        <ShingleColor />
        <Warranty />
        <br />
        <br />
        <AddonsList />
        <br />
        <AdditionalNotes />
        <div className={styles.legend}>
          <span>Indicates required</span>
        </div>
      </ContractDetails>

      <div className={styles.footer_wrapper}>
        <Button colorSchema="neutral" onClick={close} size="large" variant="text">
          Cancel
        </Button>
        <WarningPopOver productErrors={productErrors}>
          <Button
            colorSchema="primary"
            disabled={productErrors.length > 0}
            onClick={goToProductsStep}
            size="large"
          >
            <span>Proceed To {nextStepName}</span>
          </Button>
        </WarningPopOver>
      </div>
    </div>
  );
};
